import yup from '@/libs/yup';
import { RUNNER_TYPES } from '@/const';

export default yup.object({
    title: yup.string().trim(),
    idn: yup.string().required('Idn is a required field').idn(),
    runner_type: yup.string().oneOf(RUNNER_TYPES).required()
});
